import { ReactNode } from "react";

import { Button } from "@/components/ui/button";

type SettingCardProps = {
  icon: ReactNode;
  title: string;
  /** Rendered in lighter type next to the title, e.g. "(Optional)". */
  titleSuffix?: string;
  /** Right-hand pill. Each card badges a different thing, so it brings its own. */
  badge: ReactNode;
  description?: string;
  buttonLabel: string;
  isButtonDisabled?: boolean;
  testId: string;
  /** Summary of what is configured, or a note on why the card is still locked. */
  children?: ReactNode;
  onButtonClick: () => void;
};

const SettingCard = ({
  icon,
  title,
  titleSuffix,
  badge,
  description,
  buttonLabel,
  isButtonDisabled = false,
  testId,
  children,
  onButtonClick
}: SettingCardProps) => (
  <div
    className="flex flex-col gap-3 rounded-xl border border-gainsboro p-4"
    data-testid={testId}
  >
    <div className="flex flex-row items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-sm font-semibold text-txtHeading">{title}</span>
        {titleSuffix && (
          <span className="text-xs text-dim-gray">{titleSuffix}</span>
        )}
      </div>
      <div data-testid={`${testId}-badge`}>{badge}</div>
    </div>

    {children}

    {description && (
      <span className="text-xs text-dim-gray">{description}</span>
    )}

    <div className="flex justify-end">
      <Button
        variant="outline"
        className="h-10 text-sm font-semibold rounded-xl"
        disabled={isButtonDisabled}
        onClick={onButtonClick}
        data-testid={`${testId}-config-button`}
      >
        <span>{buttonLabel}</span>
      </Button>
    </div>
  </div>
);

export default SettingCard;
